/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1CoursefinancialCoursesCourseidPlansId204,
  DeleteApiV1CoursefinancialCoursesCourseidPlansId400,
  DeleteApiV1CoursefinancialCoursesCourseidPlansId401,
  DeleteApiV1CoursefinancialCoursesCourseidPlansId404,
  DeleteApiV1CoursefinancialCoursesCourseidPlansId500,
  DeleteApiV1CoursefinancialCoursesCourseidPlansIdMutationResponse,
  DeleteApiV1CoursefinancialCoursesCourseidPlansIdPathParams,
} from "../../types/courseFinancialRegistrationController/DeleteApiV1CoursefinancialCoursesCourseidPlansId.ts";

export const deleteApiV1CoursefinancialCoursesCourseidPlansIdPathParamsSchema =
  z.object({
    courseId: z.coerce.number().int(),
    id: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1CoursefinancialCoursesCourseidPlansIdPathParams>;

/**
 * @description (No Content) Requisição não encontrou resultados.
 */
export const deleteApiV1CoursefinancialCoursesCourseidPlansId204Schema =
  z.any() as unknown as ToZod<DeleteApiV1CoursefinancialCoursesCourseidPlansId204>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1CoursefinancialCoursesCourseidPlansId400Schema =
  z.any() as unknown as ToZod<DeleteApiV1CoursefinancialCoursesCourseidPlansId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1CoursefinancialCoursesCourseidPlansId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1CoursefinancialCoursesCourseidPlansId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1CoursefinancialCoursesCourseidPlansId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1CoursefinancialCoursesCourseidPlansId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1CoursefinancialCoursesCourseidPlansId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1CoursefinancialCoursesCourseidPlansId500>;

export const deleteApiV1CoursefinancialCoursesCourseidPlansIdMutationResponseSchema =
  z.lazy(
    () => deleteApiV1CoursefinancialCoursesCourseidPlansId204Schema,
  ) as unknown as ToZod<DeleteApiV1CoursefinancialCoursesCourseidPlansIdMutationResponse>;
